import React from 'react';
import CtAdminTable from './table/CtAdminTable';

const AdminContent: React.FC = () => {
  return <CtAdminTable />;
};

export default AdminContent;
